import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment-timezone";
import Button from "./Button";
import ContentLoader from "react-content-loader";
import config from "../../config.js";

class AddSlotModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      loading: false,
      error: false,
      comment: ""
    };
  }

  handleCommentChange = e => {
    this.setState({ comment: e.target.value });
  };

  handleSave = async () => {
    const startTime = this.props.selectedEvent.start;
    const patientId = this.props.selectedPatientId;
    const doctorId = this.props.doctorId;
    const slotTypeId = this.props.selectedRdvTypeId;
    const status = "TAKEN";
    const comment = this.state.comment;
    const takenBy = this.props.userName;
    //    const authorId = this.props.loggedInUserQuery.loggedInUser.id;
    this.setState({
      loading: true
    });
    let r = Math.random().toString(36);
    r = r.substr(2, r.length - 1).toUpperCase();
    let hash = //this.hashCode(
      moment()
        .valueOf()
        .toString() +
      patientId +
      r;
    //);
    //  hash = "2b632419";
    await this.props
      .createSlot({
        variables: {
          startTime,
          doctorId,
          patientId,
          slotTypeId,
          status,
          comment,
          hash,
          takenBy
        }
      })
      .then(data => {
        let selectedPatientId = null;
        let selectedRdvTypeId = null;
        let selectedRdvTypeDuration = null;
        this.props.updateRdvSelect({
          variables: {
            selectedPatientId,
            selectedRdvTypeId,
            selectedRdvTypeDuration
          }
        });
        //sendEmail if email is present
        let email = data.data.createSlot.patient.email;
        if (email && email.length > 1) {
          this.sendEmail(data.data.createSlot);
        }
        this.setState({
          loading: false,
          error: false
        });
        this.props.toggleModal();
      })
      .catch(e => {
        this.setState({
          loading: false,
          error: true
        });
        console.error("add slot", e);
      });
  };

  hashCode = (str, asString = true, seed) => {
    /*jshint bitwise:false */
    var i,
      l,
      hval = seed === undefined ? 0x811c9dc5 : seed;

    for (i = 0, l = str.length; i < l; i++) {
      hval ^= str.charCodeAt(i);
      hval +=
        (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
    }
    if (asString) {
      // Convert to 8 digit hex string
      return ("0000000" + (hval >>> 0).toString(16)).substr(-8);
    }
    return hval >>> 0;
  };
  hashCode16 = (str, asString = true, seed) => {
    /*jshint bitwise:false */
    var i,
      l,
      hval = seed === undefined ? 0x811c9dc5 : seed;

    for (i = 0, l = str.length; i < l; i++) {
      hval ^= str.charCodeAt(i);
      hval +=
        (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
    }
    if (asString) {
      // Convert to 8 digit hex string
      return "000000000000000" + (hval >>> 0).toString(16);
    }
    return hval >>> 0;
  };

  sendEmail = async data => {
    let email = data.patient.email;
    let date = data.startTime;
    let hash = data.cancelationHash;
    let rdvType = data.slotType.name;
    let doctor = data.doctor.name;
    let info = data.slotType.infos;
    let infoText = data.doctor.options.infoText;
    let locale = "fr";
    let host = config.adminHost;
    if (locale === "de" || locale === "lb") {
      date = moment(date).format("DD/MM/YYYY [um] HH:mm");
    } else {
      date = moment(date).format("DD/MM/YYYY à HH:mm");
    }

    this.props
      .sendEmail({
        variables: {
          email,
          date,
          hash,
          rdvType,
          doctor,
          info,
          infoText,
          locale,
          host
        }
      })
      .then(data => {
        //console.log("email.sned");
      })
      .catch(e => {
        console.error("error sending email to " + email, e);
      });
  };

  render() {
    const isLoading =
      this.props.getPatient.loading || this.props.getSlotType.loading;
    return (
      <div className="modal is-active">
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Confirmer RDV</p>
          </header>
          {isLoading ? (
            <section className="modal-card-body">
              <ContentLoader type="list" />
            </section>
          ) : (
            <section className="modal-card-body">
              <div className="field">
                <label className="label">Patient:</label>
                <div className="control">
                  {this.props.getPatient.Patient.nom}{" "}
                  {this.props.getPatient.Patient.prenom}
                </div>
              </div>
              <div className="field">
                <label className="label">Heure:</label>
                <div className="control">
                  {moment(this.props.selectedEvent.start).format(
                    "DD/MM/YYYY à HH:mm"
                  )}
                </div>
              </div>
              <div className="field">
                <label className="label">Type:</label>
                <div className="control">
                  {this.props.getSlotType.SlotType.name}
                </div>
              </div>
              <div className="field">
                <label className="label">Note:</label>
                <div className="control">
                  <textarea
                    className="textarea"
                    placeholder="ajoutez un note"
                    onChange={this.handleCommentChange}
                  />
                </div>
              </div>
            </section>
          )}
          <footer className="modal-card-foot">
            {this.state.error ? (
              <p className="has-text-danger">Une erreur est survenue!</p>
            ) : null}
            <Button text="Retour" onClick={this.props.toggleModal} />
            <Button
              color="#00893D"
              text="Sauvegarder"
              onClick={this.handleSave}
            />
          </footer>
        </div>
      </div>
    );
  }
}
const GET_PATIENT = gql`
  query GetPatient($id: ID!) {
    Patient(id: $id) {
      id
      nom
      prenom
      matricule
    }
  }
`;
const GET_RDVTYPE = gql`
  query GetSlotType($id: ID!) {
    SlotType(id: $id) {
      id
      name
    }
  }
`;
const CREATE_SLOT = gql`
  mutation createSlot(
    $slotTypeId: ID!
    $patientId: ID!
    $doctorId: ID!
    $startTime: DateTime!
    $status: SlotStatus!
    $comment: String
    $hash: String
    $takenBy: String
  ) {
    createSlot(
      slotTypeId: $slotTypeId
      patientId: $patientId
      startTime: $startTime
      doctorId: $doctorId
      status: $status
      comment: $comment
      cancelationHash: $hash
      takenBy: $takenBy
    ) {
      id
      startTime
      patient {
        id
        email
      }
      cancelationHash
      slotType {
        id
        name
        infos
      }
      doctor {
        id
        name
        options {
          infoText
        }
      }
    }
  }
`;
const UPDATE_RDV_SELECT = gql`
  mutation updateRDVSelect(
    $selectedPatientId: String
    $selectedRdvTypeId: String
    $selectedRdvTypeDuration: String
  ) {
    updateRDVSelect(
      selectedPatientId: $selectedPatientId
      selectedRdvTypeId: $selectedRdvTypeId
      selectedRdvTypeDuration: $selectedRdvTypeDuration
    ) @client
  }
`;

const SEND_EMAIL = gql`
  mutation SendEmailMutation(
    $email: String!
    $date: String!
    $hash: String!
    $rdvType: String!
    $doctor: String!
    $info: String!
    $infoText: String!
    $locale: String
    $host: String!
  ) {
    sendEmail(
      email: $email
      date: $date
      hash: $hash
      rdvType: $rdvType
      doctor: $doctor
      info: $info
      infoText: $infoText
      locale: $locale
      host: $host
    ) {
      success
    }
  }
`;

export default compose(
  graphql(CREATE_SLOT, {
    name: "createSlot"
  }),
  graphql(SEND_EMAIL, {
    name: "sendEmail"
  }),
  graphql(UPDATE_RDV_SELECT, {
    name: "updateRdvSelect"
    //  options: ({ doctorId }) => ({ variables: { doctorId } })
  }),
  graphql(GET_PATIENT, {
    name: "getPatient",
    options: ({ selectedPatientId }) => ({
      variables: { id: selectedPatientId }
    })
  }),
  graphql(GET_RDVTYPE, {
    name: "getSlotType",
    options: ({ selectedRdvTypeId }) => ({
      variables: { id: selectedRdvTypeId }
    })
  })
)(AddSlotModal);



// WEBPACK FOOTER //
// ./src/components/utilities/AddSlotModal.js